export default __webpack_public_path__ + "static/media/pesky_calls.0a960c7a.png";